import { css } from 'linaria'


export const spinnerContainer = css`
  display: flex;
  justify-content: center;
  margin: 10vh;
`
